<template>
  <BContainer class="mb-5">
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow class="gap-y-5">
      <BCol
        cols="12"
      >
        <h5 class="border-bottom py-2 font-weight-bold">
          <i class="fad fa-grid" /> CRMS APP
        </h5>
      </BCol>
      <BCol
        v-for="(app, index) in apps"
        :key="index"
        cols="12"
        md="4"
      >
        <BCard>
          <BCardTitle style="font-size: 15px; height: 30px; display: flex; align-items: center;">
            {{ app.title }}
          </BCardTitle>
          <BCardBody
            class="p-1 d-flex justify-content-center align-items-center"
          >
            <VideoPlayer
              :src="getVideoSrc('apps', app.src)"
              :options="{
                autoplay: false,
                controls: true
              }"
              class="border rounded-sm video-player"
            />
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>

    <b-nav
      class="mt-5"
      pills
    >
      <b-nav-item
        :to="{
          name: 'shared.documents.tutorials.technical-officers'
        }"
        active-class="active"
      >
        FS Officers
      </b-nav-item>
      <b-nav-item
        :to="{
          name: 'shared.documents.tutorials.area-managers'
        }"
        active-class="active"
      >
        Area Managers
      </b-nav-item>
    </b-nav>
    <RouterView />
  </BContainer>
</template>
<script>
import VideoPlayer from '@/views/shared/documents/components/VideoPlayer.vue'

export default {
  name: 'SharedDocumentTutorials',

  components: {
    VideoPlayer
  },

  middleware: ['auth'],

  data () {
    return {
      apps: [
        {
          title: 'Install the App or Add to Home Screen (iOS)',
          src: 'install-app-ios'
        },
        {
          title: 'Install the App or Add to Home Screen (Android)',
          src: 'install-app-android'
        }
      ]
    }
  },

  mounted () {
    // Code to run when the component is mounted
  },

  methods: {
    getVideoSrc (folder, videoName) {
      return `${window.location.origin}/videos/${folder}/${videoName}.mp4`
    }
  }
}
</script>
<style scoped>
.video-player {
  max-height: 220px;
  min-height: 220px;
  background-color: black;
  width: 100%;
}

@media  screen and (max-width: 1600px) {
  .video-player {
    max-height: 170px;
    min-height: 170px;
  }
}

@media screen and (max-width: 1200px) {
  .video-player {
    max-height: 95px;
    min-height: 95px;
  }
}

@media screen and (max-width: 516px) {
  .video-player {
    max-height: 170px;
    min-height: 170px;
  }
}
</style>
